import React, { useCallback } from "react";
import { TiptapRichTextInput } from "@pineseed/gui/component";
import { ChatControl } from "@pineseed/gui/component/ChatControl";
import { InputActionIcons } from "@pineseed/gui/component/input-action-icons";
import type { InputActionHandlers } from "@pineseed/gui/hook/useInputActionHandlers";
import { TagSearchResult } from "@pineseed/gui/types";

export interface ChatBubbleComposerProps {
  onKeyDown: (e: React.KeyboardEvent) => void;
  onEditorReady: (
    getText: () => string,
    getContentWithTags: () => string,
    clearText: () => void,
    initialHasText: boolean,
    setText: (text: string) => void,
  ) => void;
  onTextChange: (newHasText: boolean) => void;
  handleSubmit: () => void;
  hasText: boolean;
  isConnected: boolean;
  isAuthenticated: boolean;
  inputActionHandlers?: InputActionHandlers;
}

export const ChatBubbleComposer: React.FC<ChatBubbleComposerProps> = ({
  onKeyDown,
  onEditorReady,
  onTextChange,
  handleSubmit,
  hasText,
  isConnected,
  isAuthenticated,
  inputActionHandlers,
}) => {
  const onTagCreated = useCallback((tag: TagSearchResult) => {
    console.log("ChatBubbleComposer: onTagCreated called", tag);
  }, []);

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-end space-x-2 border border-muted rounded-sm mt-4">
        <TiptapRichTextInput
          className="flex-1 max-h-40 overflow-y-auto"
          onKeyDown={onKeyDown}
          placeholder="Type your message here... Use @ to reference tags"
          disabled={!isConnected || !hasText}
          onEditorReady={onEditorReady}
          portalContainer={document.body}
          onTagCreated={onTagCreated}
        />
      </div>
      <div className="flex items-end space-x-4 mt-2">
        <InputActionIcons
          className="flex-shrink-0 h-8"
          disabled={!isConnected}
          hoverDelay={250}
          isConnected={isConnected}
          isAuthenticated={isAuthenticated}
          onRecordAudio={inputActionHandlers?.onRecordAudio}
          onVoiceChat={inputActionHandlers?.onStartVoiceChat}
          onRecordVideo={inputActionHandlers?.onRecordVideo}
          onVideoChat={inputActionHandlers?.onStartVideoChat}
          onAttachDevice={inputActionHandlers?.onAttachFromDevice}
          onAttachConnection={inputActionHandlers?.onAttachFromConnection}
          onAttachWorkspace={inputActionHandlers?.onAttachFromWorkspace}
        />

        <ChatControl
          className="flex-shrink-0 h-8 border border-black rounded-sm"
          onKeyDown={onKeyDown}
          showGlobalLoading={!isConnected}
          onEditorReady={onEditorReady}
          onTextChange={onTextChange}
          handleSubmit={handleSubmit}
          hasText={hasText}
          isConnected={isConnected}
        />
      </div>
    </div>
  );
};
